import React from "react";

import {
  Select,
  MenuItem,
  Avatar,
  Typography,
  Box,
  SelectChangeEvent,
  SxProps,
  Theme,
} from "@mui/material";

import { LadyMinV2DTO } from "@/models/lady-dtos";

interface CustomSelectProps {
  options: LadyMinV2DTO[];
  value: number | undefined | "";
  onChange: (value: number) => void;
}

export const CustomSelect: React.FC<CustomSelectProps> = ({
  options,
  value,
  onChange,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleChange = (event: SelectChangeEvent<number>) => {
    const selectedValue = event.target.value as number;
    onChange(selectedValue);
  };
  const menuSx: SxProps<Theme> = {
    maxHeight: 200,
    boxShadow: "none",
    border: "1px solid #e0e0e0",
    borderTop: "none",
    overflow: "hidden",
    borderRadius: "0 0 22px 22px",
    "& .MuiMenuItem-root:last-child": {
      paddingBottom: "10px",
    },
    "& .MuiList-root": {
      padding: 0,
      maxHeight: "inherit",
      overflowY: "auto",
      "&::-webkit-scrollbar-track": {
        borderRadius: "8px",
        width: "50px",
      },
      "&::-webkit-scrollbar": {
        width: "4px",
        backgroundColor: "white",
        borderInlineColor: "white",
      },
      "&::-webkit-scrollbar-thumb": {
        borderRadius: "10px",
        backgroundColor: "#dde1de",
      },
    },
    "& .MuiMenuItem-root": {
      borderRadius: "0px",
      padding: "0px",
      paddingLeft: "15px",
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:focus": {
        backgroundColor: "transparent",
      },
      "&.Mui-selected": {
        backgroundColor: "transparent !important",
      },
    },
  };

  return (
    <Select
      value={value}
      className="w-full md:w-1/2 "
      onChange={handleChange}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      displayEmpty
      renderValue={(selected: number) => {
        if (!selected) {
          return (
            <Box display="flex" alignItems="center">
              <Avatar sx={{ marginRight: "10px", marginLeft: "-8px" }} />
              <Box ml={1}>
                <Typography fontSize={14} className="text-grey1-700 opacity-80">
                  Select lady from the list
                </Typography>
              </Box>
            </Box>
          );
        }
        const lady = options.find((option) => option.id === selected);
        return (
          <Box display="flex" alignItems="center">
            <Avatar
              src={lady?.photoSrcs.small}
              alt={lady?.firstName}
              sx={{ marginRight: "10px", marginLeft: "-8px" }}
            />
            <Box ml={1}>
              <Typography fontSize={16} fontWeight={700}>
                {lady?.firstName}
              </Typography>
              <Typography fontSize={12} variant="body2" color="textSecondary">
                {lady?.from}
              </Typography>
            </Box>
          </Box>
        );
      }}
      MenuProps={{
        PaperProps: {
          sx: menuSx,
        },
      }}
      sx={{
        height: 52,
        borderRadius: open ? "22px 22px 0 0 !important" : "22px !important",
      }}
    >
      {options.length != 1 && (
        <MenuItem
          disabled
          sx={{
            pointerEvents: "none",
            justifyContent: "center",
          }}
        >
          <Typography
            fontSize={12}
            variant="body2"
            color="textSecondary"
            className="py-1"
          >
            The ladies you last contacted
          </Typography>
        </MenuItem>
      )}
      {options.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          <Box display="flex" alignItems="center">
            <Avatar
              src={option.photoSrcs.small}
              alt={option.firstName}
              sx={{ marginRight: "10px", marginLeft: "-8px" }}
            />
            <Box ml={1}>
              <Typography fontSize={16} fontWeight={700} display="inline">
                {option.firstName}
              </Typography>
              {option.isBirthdaySoon && (
                <span style={{ color: "red", marginLeft: "8px" }}>✔️</span>
              )}
              <Typography fontSize={12} variant="body2" color="textSecondary">
                {option.from}
              </Typography>
            </Box>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};
